hrd.dashboard.msgBox = function(options, fnOk, fnCancel, fnKo) {
	options = options || {};
	var isDoubleSize = options.size == '2x' || dashboardInstance.isDoubleSize();

	var deferred = $.Deferred();
	var msgBoxSelector = '#dashboard-msgbox';
	var msgBoxContentSelector = '#dashboard-msgbox > span';
	var defaults = {
		title: 'Message Box',
		text: 'Message Box Text Extended Description',
		icon: 'warning',
		okLabel: xlate('common.dialog.ok.btn'),
		cancelLabel: xlate('common.dialog.cancel.btn'),
		koLabel: xlate('common.dialog.ko.btn'),
		modal: true,
		width: isDoubleSize ? 520 : 380,
		vw: 0.95, // viewport width percentage 
		type: 'OK_CANCEL',//available values: OK_CANCEL, OK, CANCEL, YES_NO_CANCEL
		alwaysResolve: false
	};
	options = $.extend({}, defaults, options);
	
	/* adapt width so that the dialog will not overflow */
	options.width = Math.min(options.width, $(window).width() * options.vw);

	var toIconClasses = function(icon) {
		switch (icon) {
			case 'warning':
				return 'ui-icon warning f-icon fas fa-exclamation-triangle';
			case 'info':
				return 'ui-icon info f-icon fas fa-info-circle';
			case 'error':
				return 'ui-icon error f-icon fas fa-times-circle';
			case 'help':
				return 'ui-icon help f-icon fas fa-question-circle';
			case 'comment':
				return 'ui-icon comment f-icon far fa-comment-dots';
			default:
				return 'ui-icon warning f-icon fas fa-exclamation-triangle';
		}
	};

	var dialogOpt = {
		buttonClicked: 'none',
		wait: function() {
			$('#dashboard-msgbox').waiting();
			$('#dashboard-msgbox-ok').button('option', 'disabled', true);
		},
		stopWaiting: function() {
			$('#dashboard-msgbox-ok').button('option', 'disabled', false);
			$('#dashboard-msgbox').waiting('done');
		},
		close: function(withButton) {
			withButton = withButton || 'CANCEL';
			$('#dashboard-msgbox-ok').button('option', 'disabled', false);
			$('#dashboard-msgbox').waiting('done').data('closeWithButton', withButton).dialog("close");
		},
		updateText: function(text) {
			$('#dashboard-msgbox-text').html(text);
		},
		isOk: function() {
			return this.buttonClicked === 'OK';
		},
		isKo: function() {
			return this.buttonClicked === 'KO';
		},
		isCancel: function() {
			return this.buttonClicked === 'CANCEL';
		},
		autoClose: function(millis, withButton) {
			let promise = $.timeout(millis);
			$('#dashboard-msgbox').dialog('option', 'autoClosePromise', promise);
			promise.then(() => {
				this.close(withButton);
			});
		}
	}

	if (this.$msgBox == null) {
		if (!$(msgBoxSelector).exists()) {
			var tmpl = `
				<div id="dashboard-msgbox" title="" style="display:none;">
					<span>
					<span id="dashboard-msgbox-icon"></span>
						<span id="dashboard-msgbox-text"></span>
					</span>
				</div>
			`;
			$('body').append(tmpl);
		}
		this.$msgBox = $(msgBoxSelector);

		var dialogClass = 'message-box' + (isDoubleSize ? ' message-box-2x' : '');
		this.$msgBox.dialog({
			alwaysResolve: options.alwaysResolve,
			autoOpen: false,
			resizable: false,
			closable: false,
			dialogClass: dialogClass,
			height: 'auto',
			modal: true,
			fnOk: fnOk || $.noop,
			fnCancel: fnCancel || $.noop,
			fnKo: fnKo || $.noop,
			buttons: [
				{
					id: "dashboard-msgbox-ok",
					text: options.okLabel,
					click: function(event) {
						var options = $(this).dialog('option');
						options.fnOk();
						dialogOpt.buttonClicked = 'OK';
						options.deferred.resolve(dialogOpt);
						$(this).dialog("close");
					}
				},
				{
					id: "dashboard-msgbox-ko",
					text: options.koLabel,
					click: function() {
						var options = $(this).dialog('option');
						options.fnKo();
						dialogOpt.buttonClicked = 'KO';
						if (options.alwaysResolve) {
							options.deferred.resolve(dialogOpt);
						} else {
							options.deferred.reject(dialogOpt);
						}
						$(this).dialog("close");
					}
				},
				{
					id: "dashboard-msgbox-cancel",
					text: options.cancelLabel,
					click: function() {
						var options = $(this).dialog('option');
						options.fnCancel();
						dialogOpt.buttonClicked = 'CANCEL';
						if (options.alwaysResolve) {
							options.deferred.resolve(dialogOpt);
						} else {
							options.deferred.reject(dialogOpt);
						}
						$(this).dialog("close");
					}
				}
			],
			close: function(event, ui) {
				/* reset */
				$('#dashboard-msgbox-icon').attr('class', '');
				$('#dashboard-msgbox-text').html();
				$(document).off('.msgbox');
				var options = $(this).dialog('option');
				if (options.deferred.state() == 'pending') {
					// if still pending, it must be rejected like 'cancel' button or resolved if "alwaysResolve"" is true
					let closeWithButton = $('#dashboard-msgbox').data('closeWithButton');
					let normallyResolve;
					switch (closeWithButton) {
						case 'OK':
							normallyResolve = true;
							dialogOpt.buttonClicked = 'OK';
							options.fnOk();
							break;
						case 'KO':
							normallyResolve = false;
							dialogOpt.buttonClicked = 'KO';
							options.fnKo();
							break;
						case 'CANCEL':
						default:
							normallyResolve = false;
							dialogOpt.buttonClicked = 'CANCEL';
							options.fnCancel();
							break;
					}
					if (options.alwaysResolve || normallyResolve) {
						options.deferred.resolve(dialogOpt);
					} else {
						options.deferred.reject(dialogOpt);
					}
				}
				// need to clear timeout if available
				if(options.autoClosePromise != undefined) {
					$.timeout.cancel(options.autoClosePromise);
				}

				// resolve the promise that tells that the message box can be reused, continuing with the queue //
				var mboxQueue = $(msgBoxSelector).data('mboxQueue');
				mboxQueue.dequeue().resolve(); // toglie e risolve
			},
			open: function(event, ui) {
				var $mainBtn = (options.type === 'CANCEL') ? $('#dashboard-msgbox-cancel') : $('#dashboard-msgbox-ok');
				$(this).height($(msgBoxContentSelector).height() + 'px');
				$(document).on('keypress.msgbox', function(event) {
					if (event.keyCode == 13) {
						event.preventDefault();
						$mainBtn.trigger('click');
					}
				}.bind(this));
				// focus on 'main' button
				setTimeout(function() {
					$mainBtn.focus();
				}, 0);

				// repositioning to original position (normally it will be centered)
				$(this).dialog('option', 'position', $(this).dialog('option', 'position'));

			}
		});
	}
	var mboxQueue = this.$msgBox.data('mboxQueue');
	if (mboxQueue == undefined) {
		mboxQueue = new Queue();
		this.$msgBox.data('mboxQueue', mboxQueue);
	}
	var lastPromise = $.when(mboxQueue.last()); // prendo ultimo aggiunto.... potrò eseguire quando verrà risolto
	mboxQueue.enqueue($.Deferred()); // aggiunge SUBITO deferred che verrà chiuso quando verrò chiuso io
	lastPromise.then(() => {
		/* button visibility */
		switch (options.type) {
			case 'OK':
				$('#dashboard-msgbox-ok').show();
				$('#dashboard-msgbox-ko').hide();
				$('#dashboard-msgbox-cancel').hide();
				break;
			case 'CANCEL':
				$('#dashboard-msgbox-ok').hide();
				$('#dashboard-msgbox-ko').hide();
				$('#dashboard-msgbox-cancel').show();
				break;
			case 'YES_NO_CANCEL':
				$('#dashboard-msgbox-ok').show();
				$('#dashboard-msgbox-ko').show();
				$('#dashboard-msgbox-cancel').show();
				break;
			default:
				$('#dashboard-msgbox-ok').show();
				$('#dashboard-msgbox-ko').hide();
				$('#dashboard-msgbox-cancel').show();
				break;
		}
		$('#dashboard-msgbox-icon').addClass(toIconClasses(options.icon));
		$('#dashboard-msgbox-text').html(options.text);
		$('#dashboard-msgbox-ok').button('option', 'label', options.okLabel);
		$('#dashboard-msgbox-cancel').button('option', 'label', options.cancelLabel);
		$('#dashboard-msgbox-ko').button('option', 'label', options.koLabel);
		this.$msgBox.dialog('option', 'title', options.title);
		this.$msgBox.dialog('option', 'deferred', deferred);
		this.$msgBox.dialog('option', 'fnOk', fnOk || $.noop);
		this.$msgBox.dialog('option', 'fnKo', fnKo || $.noop);
		this.$msgBox.dialog('option', 'fnCancel', fnCancel || $.noop);
		this.$msgBox.dialog('option', 'width', options.width);
		this.$msgBox.dialog('option', 'modal', options.modal);
		this.$msgBox.height($(msgBoxContentSelector).height() + 'px');
		this.$msgBox.dialog('option', 'dialogClass', 'message-box' + (isDoubleSize ? ' message-box-2x' : ''));
		this.$msgBox.dialog('option', 'alwaysResolve', options.alwaysResolve);
		this.$msgBox.dialog('option', 'autoClosePromise', undefined); // need to remove autoclosePromise
		this.$msgBox.dialog('open');

		/*
		 * used for communicate the dialogOption to caller, so that it can eventually close this dialog programmatically
		 * the notify does not resolve nor reject the promise, so it is still usable
		 */
		deferred.notify(dialogOpt);

	});

	return deferred.promise();
};

/**
 * Shortcut for a message box for showing an error dialog
 */
hrd.dashboard.errorDialog = function(message, title, options) {
	options = $.extend({}, options, {
		title: title || xlate('common.dialog.error.title.msg'),
		text: message || xlate('common.dialog.error.text.msg'),
		icon: 'error',
		okLabel: xlate('common.dialog.close.btn'),
		type: 'OK'
	})
	return this.msgBox(options);
};

/**
 * Shortcut for a message box for showing an unimplemented feature
 */
hrd.dashboard.notYetImplemented = function() {
	return this.msgBox({
		title: xlate('common.dialog.notYetImplemented.title.msg'),
		text: xlate('common.dialog.notYetImplemented.text.msg'),
		type: 'OK'
	});
};